import api from '../../plugins/api';

const getFactoryList = (params) => {
  return api.get('/api/crm/cars/factoryList', params);
};

export default getFactoryList;


